import { BusinessEmployee } from "@1games-ru/region-shared/dist/backend/requests/business";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setEmployeesIsDismissModal } from "@/domains/business/slice";
import { useEmployeesHandlers } from "@/domains/business/hooks/useEmployeesHandlers";
import BusinessDismissModal from "@/domains/business/components/BusinessDismissModal";

type Props = {
  selectedEmployee: BusinessEmployee;
  businessId: number;
  setSelectedEmployee: (employee: null) => void;
};

export default function BusinessDismissContainer({
  selectedEmployee,
  businessId,
  setSelectedEmployee,
}: Props) {
  const dispatch = useAppDispatch();
  const { isPending, removeEmployeeHandler } = useEmployeesHandlers();

  const onClose = useCallback(() => {
    dispatch(setEmployeesIsDismissModal(false));
    setSelectedEmployee(null);
  }, [dispatch, setSelectedEmployee]);

  const onConfirm = () => {
    if (businessId && selectedEmployee) {
      removeEmployeeHandler(businessId, selectedEmployee.characterId);
    }
  };

  return (
    <BusinessDismissModal
      title={selectedEmployee.name}
      position={selectedEmployee.role}
      onClose={onClose}
      onConfirm={onConfirm}
      isConfirming={isPending}
    />
  );
}
